import React from "react";
import { TFunction } from "i18next";

import { AccordionProps } from "../../../components/shared/Accordion/Accordions";

export const buildPhlebotomyFaqAccordionData = (
  t: TFunction,
): AccordionProps[] => [
  {
    key: "blood-draw-cost",
    title: t("phlebotomy.faq.bloodDrawCost.title"),
    content: t("phlebotomy.faq.bloodDrawCost.content"),
  },
  {
    key: "cannot-draw-blood",
    title: t("phlebotomy.faq.cannotDrawBlood.title"),
    content: t("phlebotomy.faq.cannotDrawBlood.content"),
  },
  {
    key: "how-long-it-takes",
    title: t("phlebotomy.faq.howLong.title"),
    content: t("phlebotomy.faq.howLong.content"),
  },
  {
    key: "choose-specific-time",
    title: t("phlebotomy.faq.specificTime.title"),
    content: t("phlebotomy.faq.specificTime.content"),
  },
  {
    key: "how-to-prepare",
    title: t("phlebotomy.faq.howToPrepare.title"),
    content: (
      <>
        {t("phlebotomy.faq.howToPrepare.content")}
        <br />
        <ul style={{ paddingLeft: "20px", marginBlock: "5px" }}>
          <li>{t("phlebotomy.faq.howToPrepare.hydrated")}</li>
          <li>{t("phlebotomy.faq.howToPrepare.clothing")}</li>
        </ul>
      </>
    ),
  },
];
